module.exports = __webpack_public_path__ + "static/media/dolar.0a5aba83.svg";